import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import PracticeAreas from "./components/PracticeAreas";
import SectionTrustBar from "../../components/feature/sections/SectionTrustBar";
import SectionAIBlock from "../../components/feature/sections/SectionAIBlock";
import SectionProcess from "../../components/feature/sections/SectionProcess";
import SectionWhyChooseUs from "../../components/feature/sections/SectionWhyChooseUs";
import SectionServiceAreas from "../../components/feature/sections/SectionServiceAreas";
import SectionTestimonials from "../../components/feature/sections/SectionTestimonials";
import SectionFAQ from "../../components/feature/sections/SectionFAQ";
import SectionFinalCTA from "../../components/feature/sections/SectionFinalCTA";

const homeAIQuestions = [
  {
    q: "What does this law firm do?",
    a: "Alice G. Gosfield & Associates, P.C. provides specialized legal representation for physicians, health care organizations, health systems, and businesses. The firm handles complex health care regulatory matters, compliance programs, contract disputes, and legal advisory services with a focus on achieving efficient and favorable outcomes.",
  },
  {
    q: "What legal services are offered?",
    a: "Legal services include health care regulatory compliance, Medicare and Medicaid reimbursement counseling, fraud and abuse avoidance (Stark Law, anti-kickback statute), managed care contracting, HIPAA privacy, business law, contract disputes, real estate transactions, and litigation support — all tailored to client-specific needs.",
  },
  {
    q: "What are the benefits of working with this firm?",
    a: "Clients receive strategic legal guidance from attorneys with decades of specialized expertise, risk reduction through proactive compliance counseling, and experienced advocacy to protect their interests. The boutique structure ensures direct partner involvement, personalized service, and efficient case handling.",
  },
];

const homeFAQs = [
  {
    q: "Who is the best health law attorney near me?",
    a: "The best health law attorney depends on your specific legal needs. Alice G. Gosfield & Associates in Philadelphia provides experienced health care regulatory counsel serving clients in all 50 states, offering strategic guidance and personalized support for physicians, health systems, and organizations.",
  },
  {
    q: "How much does a health care attorney cost?",
    a: "Legal fees vary depending on the type and complexity of your legal matter. We offer consultations to evaluate your situation and provide a clear understanding of potential costs and the best approach for your needs before committing to representation.",
  },
  {
    q: "How long does a health law case take to resolve?",
    a: "Case timelines vary widely based on the nature of the matter — from government inquiries and audits to contract negotiations and compliance reviews. Some matters resolve in weeks, while complex enforcement actions may take months depending on circumstances.",
  },
  {
    q: "Do I need a lawyer for Medicare compliance?",
    a: "If you are a health care provider dealing with Medicare reimbursement, billing audits, fraud and abuse allegations, or Stark Law compliance, experienced legal counsel is essential. The regulatory framework is highly complex, and errors can result in significant financial penalties.",
  },
  {
    q: "What is the Stark Law and how does it affect physicians?",
    a: "The Stark Law prohibits physicians from referring patients to entities they have a financial relationship with, unless an exception applies. Violations can result in significant penalties and exclusion from Medicare and Medicaid programs.",
  },
  {
    q: "Does the firm handle matters outside Pennsylvania?",
    a: "Yes. Alice G. Gosfield & Associates advises clients on federal health law and health care regulation matters across all 50 states. The firm frequently partners with local counsel for state-specific legal questions requiring state licensure.",
  },
  {
    q: "What is HIPAA and when do I need legal help with it?",
    a: "HIPAA establishes federal standards for protecting patient health information. You may need legal counsel when structuring business associate agreements, responding to OCR investigations, implementing privacy programs, or dealing with potential breach notifications.",
  },
  {
    q: "How do I schedule a consultation?",
    a: "You can schedule a consultation by calling (215) 735-2384 during business hours (Mon–Fri, 9 AM–5:30 PM) or by submitting the consultation request form on our Contact page. We typically respond within one business day.",
  },
];

export default function Home() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <HeroSection />
        <SectionTrustBar />
        <PracticeAreas />
        <SectionAIBlock questions={homeAIQuestions} />
        <SectionProcess />
        <SectionWhyChooseUs />
        <SectionServiceAreas />
        <SectionTestimonials />
        <SectionFAQ faqs={homeFAQs} />
        <SectionFinalCTA />
      </main>
      <Footer />
    </div>
  );
}
